import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import { formCardStyle } from '../../../TransitionStyles';
import { HR } from '../../../formQuestionsEnum';
import DietarySection from './DietarySection';
import HousekeepingSection from './HousekeepingSection';
import TherapySection from './TherapySection';
import FormDataDivider from '../../../FormFields/FormDataDivider';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import FormFileDrop from '../../../FormFields/FormFileDrop';
import FormTitle from '../../../FormFields/FormTitle';

DepartmentsContractedForm.propTypes = {
  permissions: PropTypes.object,
};

export default function DepartmentsContractedForm({ permissions }) {
  const fieldIds = [
    HR.LAUNDRY_IS_OUTSOURCED.id,
    HR.CURRENT_EMPLOYEE_HANDBOOK.id,
    HR.HOUSEKEEPING_IS_OUTSOURCED.id,
    HR.HOUSEKEEPING_OUTSOURCED_CATEGORY_ID.id,
    HR.HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK.id,
    HR.HOUSEKEEPING_AVERAGE_MONTHLY_COST.id,
    HR.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR.id,
    HR.HOUSEKEEPING_OUTSOURCED_COMP_HAS_HR_FILES.id,
    HR.DIETARY_IS_OUTSOURCED.id,
    HR.DIETARY_OUTSOURCED_CATEGORY_ID.id,
    HR.OUTSOURCED_DIETARY_VENDOR.id,
    HR.DIETARY_OUTSOURCED_PHONE.id,
    HR.DIETARY_OUTSOURCED_EMAIL.id,
    HR.DIETARY_OUTSOURCED_HOURS_PER_WEEK.id,
    HR.DIETARY_OUTSOURCED_COMP_HAS_HR_FILES.id,
    HR.THERAPY_OUTSOURCED_CATEGORY_ID.id,
    HR.THERAPY_VENDOR.id,
    HR.THERAPY_OUTSOURCED_COMP_HAS_HR_FILES.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Departments Contracted
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          <HousekeepingSection permissions={permissions} />

          {HR.LAUNDRY_IS_OUTSOURCED.id in permissions && (
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" color="text.secondary">
                  Laundry
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <FormButtonOptions
                  fieldName={HR.LAUNDRY_IS_OUTSOURCED.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[HR.LAUNDRY_IS_OUTSOURCED.id],
                    options: [
                      { label: 'Outsourced', value: true },
                      { label: 'In House', value: false },
                    ],
                  }}
                />
              </Grid>
              <FormDataDivider />
            </Grid>
          )}

          <DietarySection permissions={permissions} />

          <TherapySection permissions={permissions} />

          {HR.CURRENT_EMPLOYEE_HANDBOOK.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Current employee handbook', fieldType: 'file' }} />
              <FormFileDrop
                fieldName={HR.CURRENT_EMPLOYEE_HANDBOOK.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.CURRENT_EMPLOYEE_HANDBOOK.id],
                  fileTypeId: FILE_TYPES.EMPLOYEE_HANDBOOK,
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
